import ym from 'react-yandex-metrika';

import { getShortUrl } from '@yandex-int/k-common/client/api';
import { copyTextToClipboard } from 'platform-components/utils';
import { GRAVITIES, NOTIFICATION_THEMES } from 'platform-components/constants';

import { NOTIFICATION_CLOSE_DELAY } from 'common.components/user/class.constants';
import { redirectToMesHomeworkPageUrl } from 'utils/external-lms/external-lms';
import { getIsInStudentStatsBundle } from 'utils/get-is-in-student-stats-bundle';

import { mixinContextMembers } from './context';

export function mixinToastMembers<TBase extends ReturnType<typeof mixinContextMembers>>(Base: TBase) {
    return class extends Base {
        getAssignToastParams = () => {
            const {
                isTeacherFromMes,
                match: { path },
            } = this.props;
            const {
                staticUrls: { labSubjectLessons },
            } = this.context;

            // TODO: EDUCATION-34116
            // Этот тост не показывается, пользователя после выдачи сразу редиректит в МЭШ
            if (isTeacherFromMes) {
                return {
                    getNotificationMessageCallback: this.onAssignInExternalLmsToastAction,
                    notificationMessageId: 'toast.goToExternalLms.mes',
                };
            }

            if (path.startsWith(labSubjectLessons)) {
                return {
                    getNotificationMessageCallback: this.onAssignFromLessonsToastAction,
                    notificationMessageId: 'toast.lessonAssigned.copyLessonLink',
                };
            }

            // Оставляем пользователя на вкладке и в тосте предлагаем перейти на Занятия
            return {
                getNotificationMessageCallback: this.onAssignToastAction,
                notificationMessageId: 'toast.goToLessons',
            };
        };

        onAssignInExternalLmsToastAction = (_: number, studentLink: string, mesBackUrl: string) => {
            // TODO: EDUCATION-34116
            // Не используется – мы сразу редиректим в мэш, пользователю не нужен тост
            return () => redirectToMesHomeworkPageUrl(mesBackUrl, studentLink, '', '');
        };

        onAssignFromLessonsToastAction = async (assignedLessonId: number) => {
            const { getRouterPath, courseId, showIntlMessageNotification, me } = this.props;
            const {
                staticUrls: { kids },
                prefix,
                basePath,
            } = this.context;
            const link = `${basePath}${prefix}${getRouterPath(kids)}?course=${courseId}&lesson=${assignedLessonId}`;
            const shortLink = await getShortUrl(link);

            return () => {
                if (courseId) {
                    copyTextToClipboard(shortLink);

                    showIntlMessageNotification({
                        closeDelay: 3000,
                        gravity: GRAVITIES.BOTTOM,
                        messageId: 'toast.lesson.lessonLinkIsCopied',
                        theme: NOTIFICATION_THEMES.TOAST,
                        mix: 'lesson-view__copy-link-toast',
                    });

                    ym('reachGoal', 'teacher_copy_lesson_link', {
                        user_id: me?.id,
                        clesson_id: assignedLessonId,
                        from: 'popup',
                    });
                } else {
                    showIntlMessageNotification({
                        messageId: 'lessonLink.cannotCopyLessonLink',
                        theme: NOTIFICATION_THEMES.FAIL,
                        closeDelay: NOTIFICATION_CLOSE_DELAY,
                    });
                }
            };
        };

        onAssignToastAction = () => {
            const {
                clearEditor,
                getRouterPath,
                history,
                location: { pathname },
                match: {
                    params: { subject },
                },
                toggleLessonModal,
            } = this.props;

            const {
                staticUrls: { labSubjectLessonsActive },
            } = this.context;

            return () => {
                const activeLessonsPath = getRouterPath(labSubjectLessonsActive, { subject });

                if (getIsInStudentStatsBundle(pathname)) {
                    // бандлы разные, переход через history.push невозможен
                    if (typeof window !== 'undefined') {
                        window.location.href = activeLessonsPath;
                    }
                } else {
                    history.push(activeLessonsPath);
                }

                toggleLessonModal(false);
                clearEditor();

                // TODO: EDUCATION-43196: Разобраться с метрикой
                //
                // ym('reachGoal', 'teacher_look_program', {
                //     from: REDIRECT_SOURCE.LESSON,
                //     cc_slug: containerSlug,
                //     module_id: lessonModuleId,
                //     lesson_id: lesson.id,
                // });

                // ym('reachGoal', 'teacher_lesson_creation_opened_module', {
                //     subject,
                //     moduleId: lessonModuleId,
                // });
            };
        };
    };
}
